// Header组件不需要React导入，因为使用了新的JSX转换

/**
 * 页面头部组件
 * 显示应用标题和导航
 */
const Header: React.FC = () => {
  return (
    <header className="navbar bg-base-100 shadow-lg">
      <div className="container mx-auto">
        {/* Logo和标题 */}
        <div className="navbar-start">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-r from-primary to-secondary rounded-lg flex items-center justify-center">
              <span className="text-white text-xl font-bold">T</span>
            </div>
            <div>
              <h1 className="text-xl font-bold text-base-content">
                TikTok监控
              </h1>
              <p className="text-xs text-base-content/60">
                商品销量分析工具
              </p>
            </div>
          </div>
        </div>

        {/* 中间区域 */}
        <div className="navbar-center hidden lg:flex">
          <ul className="menu menu-horizontal px-1">
            <li>
              <a className="text-base-content/70 hover:text-primary">
                监控面板
              </a>
            </li>
            <li>
              <a className="text-base-content/70 hover:text-primary">
                数据分析
              </a>
            </li>
            <li>
              <a className="text-base-content/70 hover:text-primary">
                使用说明
              </a>
            </li>
          </ul>
        </div>

        {/* 右侧区域 */}
        <div className="navbar-end">
          {/* 主题切换 */}
          <div className="dropdown dropdown-end">
            <div tabIndex={0} role="button" className="btn btn-ghost btn-circle">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                className="w-5 h-5 stroke-current"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z"
                />
              </svg>
            </div>
            <ul
              tabIndex={0}
              className="menu dropdown-content z-[1] p-2 shadow bg-base-100 rounded-box w-32 mt-4"
            >
              <li>
                <button
                  onClick={() => document.documentElement.setAttribute('data-theme', 'tiktok')}
                  className="justify-start"
                >
                  TikTok
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.documentElement.setAttribute('data-theme', 'light')}
                  className="justify-start"
                >
                  浅色
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.documentElement.setAttribute('data-theme', 'dark')}
                  className="justify-start"
                >
                  深色
                </button>
              </li>
            </ul>
          </div>

          {/* 移动端菜单 */}
          <div className="dropdown dropdown-end lg:hidden">
            <div tabIndex={0} role="button" className="btn btn-ghost btn-circle">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h7"
                />
              </svg>
            </div>
            <ul
              tabIndex={0}
              className="menu dropdown-content z-[1] p-2 shadow bg-base-100 rounded-box w-52 mt-4"
            >
              <li><a>监控面板</a></li>
              <li><a>数据分析</a></li>
              <li><a>使用说明</a></li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 